import React from 'react';

export default {
  title:
    'Please confirm the name, date of birth and the address for the shareholders who are actively involved in running the business.',
  boldCopy: 'Please note:',
  bulletList: {
    firstPoint: () => (
      <>
        We only need the information of shareholders with{' '}
        <strong>voting rights</strong> that cover 50% of the business.
      </>
    ),
    secondPoint:
      'The shareholders you select must have UK residency or indefinite leave to remain.',
    thirdPoint: 'Please provide names as they appear on ID documents.'
  },
  list: {
    title:
      'Add the details of all shareholders that play a day-to-day role in the business by clicking on them',
    'over-50-percent-warning':
      'Your selection needs to add up to 50% or more of business ownership.'
  },
  confirm:
    'Check here to confirm that the above information is correct and the names of the shareholders appear as they do on their ID.'
};
